/**
 * [pug template]
 */
<template lang="pug">
  div(class="olst-tooltip")
    .tooltip-container(v-show="isDisplayed", transition="tooltip")
      .tooltip-header(v-text="header")
      .tooltip-image-container
        img(:src="image")
      .tooltip-footer(v-text="footer")
</template>
/**
 * [javascript application]
 */
<script>
export default {
  name: 'tooltip',
  props: {
    header: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: '#'
    },
    footer: {
      type: String,
      default: ''
    },
    isDisplayed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
/**
 * [scss styles]
 */
<style lang="scss">
</style>



// WEBPACK FOOTER //
// TooltipWithImage.vue?79a3ba20